<template>
  <div class="px-5">
    <v-col cols="12" class="py-0 group-bread-scrumb">
      <router-link :to="{ name: 'Promotion' }"> Quản lý mã </router-link>
      <span> > </span>
      <router-link :to="{ name: 'DetailPromotion' }"> Chi tiết mã </router-link>
    </v-col>
    <div class="create-form">
      <div class="new-promotion-detail d-flex justify-space-between">
        <div class="d-flex">
          <div style="width: 250px">
            <div class="mb-2">Mã</div>
            <div class="mb-2">Hình thức áp dụng</div>
            <div v-if="code.type == promotionPrivate" class="mb-2">Độ dài</div>
            <div v-if="code.type == promotionPrivate" class="mb-2">
              Số lượng mã
            </div>
            <div v-if="code.type == promotionGeneral" class="mb-2">
              Số lượt sử dụng tối đa
            </div>
            <div class="mb-2">Đã sử dụng</div>
            <div>Chiến dịch:</div>
          </div>
          <div>
            <div class="mb-2">{{ code.code }}</div>
            <div v-if="campaignFormObj" class="mb-2">
              {{ campaignFormObj[code.type] }}
            </div>
            <div v-if="code.type == promotionPrivate" class="mb-2">
              {{ code.codeLength }}
            </div>
            <div v-if="code.type == promotionPrivate" class="mb-2">
              {{ code.numberOfCode }}
            </div>
            <div v-if="code.type == promotionGeneral" class="mb-2">
              {{ code.numberOfAvailable }}
            </div>
            <div class="mb-2">{{ code.numberOfUsed }}</div>
            <div>
              <a
                v-if="code.campaign"
                class="link-edit"
                style="color: #4c9aff; font-weight: 500"
                target="_blank"
                :href="`/campaign/update/${code.campaign.id}`"
              >
                {{ code.campaign.title }}
              </a>
              <span v-else> -- </span>
            </div>
          </div>
        </div>
        <div>
          <div>
            <v-btn 
              v-if="checkAuthorization('oms-code_update')"
              class="btn-save" 
              small 
              @click="showAddCode"
            >
              <span v-if="code.type == promotionPrivate">+ Thêm mã</span>
              <span v-if="code.type == promotionGeneral">+ Thêm lượt</span>
            </v-btn>
          </div>
          <div>
            <v-btn :disabled="code.type == promotionGeneral" class="btn-export mx-0" small @click="exportData">
              Export
            </v-btn>
          </div>
        </div>
      </div>
      <div v-if="code.campaign">
        <h3 class="my-3">Lịch sử sử dụng</h3>
        <div class="new-promotion-detail">
          <h3>Lọc dữ liệu</h3>
          <div class="d-flex">
            <div class="d-flex w-100">
              <div class="content-runner">Đơn tạo từ</div>
              <div>
                <date-picker
                  v-model="filter.start_date"
                  type="date"
                  :disabledDate="disabledEndDate"
                ></date-picker>
              </div>
            </div>
            <div class="d-flex w-100">
              <div class="content-runner">Đơn tạo đến</div>
              <div>
                <date-picker
                  v-model="filter.end_date"
                  type="date"
                  :disabledDate="disabledStartDate"
                ></date-picker>
              </div>
            </div>
            <div class="d-flex w-100">
              <div class="content-runner">Mã cụ thể</div>
              <div>
                <v-text-field
                  placeholder="Nhập mã"
                  class="text-field-no-message custome-height-promotion"
                  outlined
                  v-model="filter.promotion_sub_code"
                  :disabled="code.type == promotionGeneral"
                  dense
                ></v-text-field>
              </div>
            </div>
            <div class="w-100">
              <v-btn class="mx-0 px-6" color="blue" small @click="filterData()">
                Lọc
              </v-btn>
            </div>
          </div>
        </div>
      </div>
      <div v-if="code.campaign" class="my-3">
        <div class="group-form">
          <div>
            <v-simple-table class="table-custom">
              <thead>
                <tr>
                  <th class="text-center">Mã sử dụng</th>
                  <th class="text-center">Mã đơn hàng</th>
                  <th class="text-center">Thời gian tạo đơn</th>
                  <th class="text-center">Số lần sử dụng</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="!historyData.length">
                  <td colspan="8" v-if="!isLoading">Không có dữ liệu</td>
                  <td colspan="8" v-if="isLoading">Đang tải dữ liệu...</td>
                </tr>
                <template v-if="historyData.length">
                  <tr v-for="(item, index) in historyData" :key="index">
                    <td class="text-center">
                      {{
                        item.promotionSubCode
                          ? item.promotionSubCode
                          : item.promotionCode
                      }}
                    </td>
                    <td class="text-center">{{ item.orderCode }}</td>
                    <td class="text-center">
                      {{ formatDate(item.createdAt) }}
                    </td>
                    <td class="text-center">{{ item.numberOfUsed }}</td>
                  </tr>
                </template>
              </tbody>
            </v-simple-table>
          </div>
        </div>
      </div>
    </div>

    <v-col cols="12">
      <v-row>
        <v-col offset="4" cols="8" class="py-0">
          <v-row v-if="totalPage">
            <v-col cols="7" class="d-flex justify-end py-0">
              <p class="pt-3">Rows per page:</p>
            </v-col>
            <v-col cols="1" class="justify-end py-0">
              <v-select
                class="text-field"
                :items="[
                  { id: 10 },
                  { id: 20 },
                  { id: 30 },
                  { id: 40 },
                  { id: 50 },
                ]"
                item-value="id"
                item-text="id"
                :aLight="'right'"
                placeholder="Chọn"
                attach
                dense
                type="number"
                v-model="numPerPage"
                @change="getHistory(1)"
                :menu-props="{ top: true, offsetY: true, maxHeight: '150' }"
              ></v-select>
            </v-col>
            <v-col cols="1" class="justify-end py-0">
              <p class="pt-3 text-center">
                {{ (page - 1) * numPerPage + 1 }}-{{
                  (page - 1) * numPerPage + historyData.length
                }}
                of {{ totalItem }}
              </p>
            </v-col>
            <v-col cols="3" class="px-0 py-0">
              <v-pagination
                v-model="page"
                class="d-flex justify-end pagination-custom"
                :length="totalPage"
                :total-visible="7"
                @input="getHistory()"
              ></v-pagination>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
    <v-dialog
      persistent
      v-if="isShowAddCode"
      v-model="isShowAddCode"
      max-width="480"
    >
      <AddCodeModal
        :code="code"
        @close="isShowAddCode = false"
        @success="addCodeSuccess"
      />
    </v-dialog>
  </div>
</template>

<script>
import * as moment from "moment";

import { promotionGeneral, promotionPrivate } from "../../helpers/constants";

import RepositoryFactory from "@/repositories/RepositoryFactory";
const PromotionRepository = RepositoryFactory.get("promotion");
const CampaignRepository = RepositoryFactory.get("campaign");

import { formatDate } from "@/helpers/utils";

import AddCodeModal from "./detail/AddCodeModal.vue";

export default {
  name: "detail",
  components: {
    AddCodeModal,
  },
  props: {},
  data() {
    return {
      code: {
        id: null,
        code: null,
        type: null,
        count: null,
      },
      numPerPage: 10,
      page: 1,
      totalPage: null,
      historyData: [],
      isShowAddCode: false,
      isLoading: false,
      campaignFormObj: {},
      promotionGeneral,
      promotionPrivate,
      filter: {
        start_date: null,
        end_date: null,
        promotion_sub_code: null,
      },
      totalItem: 0,
    };
  },
  computed: {},
  async created() {
    await this.getListAttributes();
    this.getHistory();
    this.getDetail();
    Bus.$on("promotion_sub_generated", () => {
      this.getHistory();
      this.getDetail();
    });
  },
  beforeDestroy() {
    Bus.$off("promotion_sub_generated");
  },
  methods: {
    disabledEndDate(date) {
      if (!this.filter.end_date) {
        return false;
      }
      return date > new Date(this.filter.end_date);
    },
    disabledStartDate(date) {
      if (!this.filter.start_date) {
        return false;
      }
      return date < new Date(this.filter.start_date);
    },
    addCodeSuccess(data) {
      if (data.type == promotionGeneral) {
        this.getHistory();
        this.getDetail();
      }
      this.isShowAddCode = false;
    },
    async getDetail() {
      const res = await PromotionRepository.getDetail(this.$route.params.id);
      this.code = res.data;
    },
    showAddCode() {
      this.isShowAddCode = true;
    },
    exportData() {
      PromotionRepository.exportPromotion(this.$route.params.id);
      this.$swal({
        title: "Thành công",
        text: "Dữ liệu đang được tải xuống",
        icon: "success",
        timer: 2000,
        showConfirmButton: false,
      });
    },
    saveCode() {},
    async getListAttributes() {
      const res = await CampaignRepository.getOptions();
      res.data.applicableForm.forEach(
        (item) => (this.campaignFormObj[item.id] = item.name)
      );
    },
    filterData() {
      this.getHistory(1);
    },
    async getHistory(page = null) {
      if (page) {
        this.page = 1;
      }
      this.isLoading = true;
      let params = {
        start_date: this.filter.start_date ? moment(this.filter.start_date).format('YYYY/MM/DD') : null,
        end_date: this.filter.end_date ? moment(this.filter.end_date).format('YYYY/MM/DD') : null,
        promotion_sub_code: this.filter.promotion_sub_code ? this.filter.promotion_sub_code.trim() : null,
        limit: this.numPerPage,
        page: this.page,
      };
      const res = await PromotionRepository.getHistory(
        this.$route.params.id,
        params
      );
      if (res && res.data) {
        this.historyData = res.data;
        this.totalItem = res.totalItem;
        this.totalPage = Math.ceil(res.totalItem / this.numPerPage);
      }
      this.isLoading = false;
    },
    formatDate(date) {
      return moment(date).format("DD-MM-YYYY HH:mm");
    },
  },
};
</script>
<style scoped lang="scss">
.btn-save {
  background: #ff5500 !important;
  color: #fff;
  width: 100px;
  margin-bottom: 10px !important;
}
.btn-export {
  background: #048f0a !important;
  color: #fff !important;
  width: 100px;
}
.create-form {
  background: #fff;
  padding: 10px;
}
.group-form {
  background: #fafbff;
  border-radius: 10px;
}
.text-bold {
  font-weight: bold;
}

.btn-info {
  background: #6587ff !important;
  color: #fff;
}

.icon-search {
  left: 40px;
  position: relative;
}
.table-custom {
  background: unset !important;

  thead th {
    background: unset;
    font-weight: bold !important;
    font-size: 14px;
    border-right: 1px solid #fff;
    background: #6587ff33;
    border-bottom: 1px solid #fff;
  }

  td {
    border-right: 1px solid #fff;
    padding-left: 8px !important;
    padding-right: 8px !important;
    background: #eeeeee;
  }
}
.new-promotion-detail {
  background: #f1f2ff;
  padding: 20px;
  border-radius: 4px;
}
.content-runner {
  width: 100px;
}
</style>

<style lang="scss">
.text-field fieldset {
  background: #fff !important;
}
.text-search {
  .v-input__slot {
    min-height: 20px !important;
    padding-left: 35px !important;
  }
}

.v-select-custom {
  .v-subheader {
    font-weight: bold;
    background: #ececec;
    color: #000;
  }
}

.group-bread-scrumb {
  position: relative;
  top: -30px;
  z-index: 99;
  height: 0;
  font-weight: bold;
  font-size: 17px;
  a {
    text-decoration: none !important;
    color: #000;
  }
}
.text-field-no-message {
  .v-text-field__details {
    display: none !important;
  }
}
.custome-height-promotion {
  .v-input__slot {
    min-height: 34px !important;
    margin-bottom: 0 !important;
    background-color: #fff !important;
    width: 210px !important;
  }
  &.v-input--is-disabled {
    .v-input__slot {
      background-color: #cccccc80 !important;
    }
  }
}
</style>
